import {useQueryState} from 'shared/web';

import {queryParams} from '../../utils/queryParams';

export function useSectionNavigation(defaultSectionId = '') {
  const [activeSectionIdQuery, setActiveSectionIdQuery] = useQueryState(
    queryParams.COMPONENT_SECTIONS_SECTION,
    true
  );

  const activeSectionId = activeSectionIdQuery ?? defaultSectionId;

  const onSectionChange = (sectionId: string) => {
    setActiveSectionIdQuery(sectionId);
  };

  return {onSectionChange, activeSectionId};
}
